enum ROUTES {
  ROOT = '/',
  LOGIN = '/sign-in-business',
  SIGNUP = '/sign-up-business',
  UPDATE_USER = '/update-user',
  UPDATE_PASSWORD = '/update-password',
  FORGOT_PASSWORD = '/forgot-password',
  // ROOT_AUTH = '/register-new-user',
  // REGISTER_NEW_USER = '/register-new-user',
  OLD_BUSINESS_REGISTER = '/old-business-register',
  OLD_PRODUCTS = '/old-products',
  OLD_GESTION_PEDIDOS = '/old-gestion-pedidos',
  OLD_REGISTRO_EMPLEADOS = '/old-registro-empleados'
}

export default ROUTES;
